import React from 'react';

/**
 * Azure DevOps-style Work Item Type Icons
 * Professional SVG icons matching Azure DevOps design language
 */

export const FeatureIcon: React.FC<{ className?: string; size?: number }> = ({ 
  className = '', 
  size = 16 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 16 16" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect x="2" y="2" width="12" height="12" rx="2" fill="#773ADC" />
    <path 
      d="M8 5L11 8L8 11L5 8L8 5Z" 
      fill="white" 
      fillOpacity="0.9"
    />
  </svg>
);

export const UserStoryIcon: React.FC<{ className?: string; size?: number }> = ({ 
  className = '', 
  size = 16 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 16 16" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect x="2" y="2" width="12" height="12" rx="1.5" fill="#009CCC" />
    <path 
      d="M5 6H11M5 8H11M5 10H9" 
      stroke="white" 
      strokeWidth="1.2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

export const TaskIcon: React.FC<{ className?: string; size?: number }> = ({ 
  className = '', 
  size = 16 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 16 16" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle cx="8" cy="8" r="6" fill="#10A37F" />
    <path 
      d="M5.5 8L7 9.5L10.5 6" 
      stroke="white" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

export const BugIcon: React.FC<{ className?: string; size?: number }> = ({ 
  className = '', 
  size = 16 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 16 16" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle cx="8" cy="8" r="6" fill="#E60000" />
    <g transform="translate(5, 4.5)">
      <ellipse cx="3" cy="2" rx="2.5" ry="1.8" fill="white" fillOpacity="0.9" />
      <circle cx="2" cy="1.8" r="0.5" fill="#E60000" />
      <circle cx="4" cy="1.8" r="0.5" fill="#E60000" />
      <path 
        d="M1 0.5C1 0.5 1.5 0 2 0M5 0.5C5 0.5 4.5 0 4 0" 
        stroke="white" 
        strokeWidth="0.8" 
        strokeLinecap="round"
      />
      <path 
        d="M0.5 2C0.5 2 0.5 2.5 0.8 3M5.5 2C5.5 2 5.5 2.5 5.2 3" 
        stroke="white" 
        strokeWidth="0.6" 
        strokeLinecap="round"
      />
      <ellipse cx="3" cy="4.5" rx="2" ry="1.5" fill="white" fillOpacity="0.85" />
    </g>
  </svg>
);

// Helper components for easier usage
export const EpicIcon: React.FC<{ className?: string; size?: number }> = ({
  className = '',
  size = 16,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect x="2" y="2" width="12" height="12" rx="2" fill="#FF8C00" />
    <path
      d="M8 4L12 8L8 12L4 8L8 4Z"
      fill="white"
      fillOpacity="0.95"
    />
    <path
      d="M8 6.5L10 8L8 9.5L6 8L8 6.5Z"
      fill="#FF8C00"
    />
  </svg>
);

export const WorkItemIcon: React.FC<{
  type: 'EPIC' | 'FEATURE' | 'USER_STORY' | 'TASK' | 'BUG';
  className?: string;
  size?: number;
}> = ({ type, className, size }) => {
  switch (type) {
    case 'EPIC':
      return <EpicIcon className={className} size={size} />;
    case 'FEATURE':
      return <FeatureIcon className={className} size={size} />;
    case 'USER_STORY':
      return <UserStoryIcon className={className} size={size} />;
    case 'TASK':
      return <TaskIcon className={className} size={size} />;
    case 'BUG':
      return <BugIcon className={className} size={size} />;
    default:
      return <TaskIcon className={className} size={size} />;
  }
};

export default WorkItemIcon;
